var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMarketPlace = function SvgIconMarketPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 111,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-market-place_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 10,
    fill: "url(#icon-market-place_svg__b)",
    rx: 21,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.788 42.175a8.958 8.958 0 0 1-10 0 8.844 8.844 0 0 1-5.025 1.55 8.591 8.591 0 0 1-3.513-.738V53.75A3.761 3.761 0 0 0 40 57.5h4.375V50a2.5 2.5 0 0 1 2.5-2.5h6.25a2.5 2.5 0 0 1 2.5 2.5v7.5H60a3.761 3.761 0 0 0 3.75-3.75V42.8a8.73 8.73 0 0 1-8.962-.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C0B0",
    d: "M46.875 50h6.25v7.5h-6.25V50ZM42.699 40.5l2.117-18H40.34a3.75 3.75 0 0 0-3.556 2.564l-2.703 8.11a6.076 6.076 0 0 0 2.345 7.095 6.386 6.386 0 0 0 6.273.231ZM65.5 33.174l-2.706-8.11a3.75 3.75 0 0 0-3.557-2.564h-4.053l2.145 18.227a6.172 6.172 0 0 0 5.825-.458 6.072 6.072 0 0 0 2.346-7.095Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.96 39.656a1.22 1.22 0 0 1 .671-.29L52.648 22.5h-5.296l-2 17c.096.042.185.096.266.161a6.41 6.41 0 0 0 8.342-.005Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-market-place_svg__b",
    x1: 10,
    x2: 90,
    y1: 58,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56C4E",
    stopOpacity: 0.84
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-market-place_svg__a",
    width: 100,
    height: 111,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 11,
    result: "effect1_dropShadow_641_735778"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.9125 0 0 0 0 0.713268 0 0 0 0 0.585521 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_735778"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_641_735778",
    result: "shape"
  })))));
};
export default SvgIconMarketPlace;